import { BundleBuilderStoreMixinComponent } from '@theme/bundle-builder-mixin-store';

/** @typedef {import('./bundle-builder-mixin.js').BundleBuilderPropSpec} BundleBuilderPropSpec */

export class BundleBuilderCartStarterComponent extends BundleBuilderStoreMixinComponent {
  /** @type {Record<string, BundleBuilderPropSpec>} */
  props = {
    starterId: {
      type: 'string',
      required: true,
      attributeName: 'data-starter-id',
    },
    starterTitle: {
      type: 'string',
      required: true,
      attributeName: 'data-starter-title',
    },
    starterItems: {
      type: 'object',
      required: true,
      attributeName: 'data-starter-items',
      defaultValue: {
        subscription_products: [],
        one_time_products: [],
      },
    },
  };

  /** @type {string} */
  starterId;

  /** @type {string} */
  starterTitle;

  /** @type {{ subscription_products: Array<{ title: string, productId: number, quantity: number }>, one_time_products: Array<{ title: string, productId: number, quantity: number }> }} */
  starterItems;

  get isSelected() {
    return this.state.activeCartStarterId === this.starterId;
  }

  handleStarterClick() {
    const items = (this.state.purchaseType === 'subscribe' ? this.starterItems.subscription_products : this.starterItems.one_time_products).filter((item) =>
      this.getters.getProduct(item.productId)
    );

    if (this.state.items.length > 0 && !this.isSelected) {
      const dialog = document.getElementById('bundle-builder-cart-starter-confirm');
      const triggerButton = this.querySelector('button');

      if (dialog != null && typeof /** @type {any} */ (dialog).prompt === 'function') {
        /** @type {import('./bundle-builder-component-cart-starter-confirm.js').BundleBuilderCartStarterConfirmDialog} */ (dialog).prompt(
          this.starterTitle,
          () => {
            this.mutations.applyCartStarter(items, this.starterId);
          },
          triggerButton instanceof HTMLElement ? triggerButton : null
        );
        return;
      }
    }

    this.mutations.applyCartStarter(items, this.starterId);
  }

  onStateUpdate() {
    const button = this.querySelector('button');

    if (!(button instanceof HTMLButtonElement)) return;

    button.classList.toggle('bundle-builder-cart-starter__button--selected', this.isSelected);
    button.setAttribute('aria-pressed', this.isSelected ? 'true' : 'false');
  }
}

if (!customElements.get('bundle-builder-cart-starter-component')) {
  customElements.define('bundle-builder-cart-starter-component', BundleBuilderCartStarterComponent);
}
